import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'search-v2',
		path: '/search',
		component: loadable(async () => import(/* webpackChunkName: "pages/search_v2" */ './index'), {
			exportName: 'SearchV2',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
